<template>
    <div v-if="recommendedProducts.length">
        <v-card-title>{{$t('youMayLike')}}</v-card-title>
        <v-divider></v-divider>
        <v-slide-group
                v-model="recommendedProducts"
                class="pa-4"
                active-class="success"
                show-arrows
        >
            <v-slide-item
                v-for="product in recommendedProducts"
                :key="product.id"
            >
                <div class="px-2" style="max-width: 250px">
                    <product-card
                        class="general_card px-4"
                        :product="product"
                    ></product-card>
                </div>
            </v-slide-item>
        </v-slide-group>
        <v-divider></v-divider>
    </div>
</template>

<script>

    import ProductCard from '../general-card/GeneralCard';
    import ProductService from '../../../../app-front/services/api/ProductService';
    import './products-you-like.scss'

    export default {
        name: "ProductsYouLike",
        props: ['product'],
        components: {ProductCard},
        data(){
            return {
                recommendedProducts: [],
                model: null,
            }
        },
        methods: {
            getProducts() {
                const params = { productId: this.product };

                ProductService.getRecommendedProducts(params)
                .then(res => {
                    this.recommendedProducts = res.data.data;
                })
                .catch(err => {
                    console.log(err);
                })
            }
        },
        created() {
            this.getProducts();
        },
        watch: {
            product: {
                handler() {
                    this.getProducts()
                },
                deep: true
            }
        }
    }
</script>

<style scoped>
    .general_card {
        width: 280px!important;
    }
    /*Mobile version*/
    @media screen and (max-width: 800px) {
        .general_card {
            width: 240px!important;
        }
    }
</style>
